import { useState } from "react";
import FilterJourney from "../partials/actions/FilterCustomerJourney";
import CreateIndustries from "../partials/Industry/CreateIndustries";
import OperationJourneyTable from "../partials/dashboard/OperationJourneyManagementTable";
import OperationJourneyModal from "../partials/OperationJourney/OperationJourneyModal";

const OperationJourneyManagement = () => {
  const [industriesType, setIndustriesType] = useState('');
  const [filteredData, setFilteredData] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");

  const toggleModal = (type = "") => {
    setShowModal(!showModal);
    setModalType(type);
  };

  return (
    <>
      <div className=" flex justify-end mb-8">
        <div className="grid grid-flow-col sm:auto-cols-max justify-end sm:justify-end gap-2">
          <FilterJourney
            setIndustriesType={setIndustriesType}
            industriesType={industriesType}
            filteredData={filteredData}
            setFilteredData={setFilteredData}
          />
          <div className="flex flex-col gap-2">
            <button
              onClick={() => toggleModal("journey")}
              className="bg-transparent hover:bg-indigo-500 text-indigo-700 font-semibold hover:text-white py-2 px-4 border border-indigo-500 hover:border-transparent rounded transition-colors duration-200"
            >
              Add Operation Journey
            </button>


            <button
              onClick={() => toggleModal("industry")}
              className="bg-transparent hover:bg-green-500 text-green-700 font-semibold hover:text-white py-2 px-4 border border-green-500 hover:border-transparent rounded transition-colors duration-200"
            >
              Add Industry
            </button>

          </div>

        </div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <OperationJourneyTable
          industriesType={industriesType}
          filteredData={filteredData}
        />
      </div>
      {showModal && modalType === "journey" && (
        <OperationJourneyModal 
            mode="create" 
            onClose={toggleModal}
        />
      )}
      {showModal && modalType === "industry" && (
        <CreateIndustries toggleModal={toggleModal} />
      )}
    </>
  );
}

export default OperationJourneyManagement;
